import React, { useState, useEffect } from 'react';
import './MTT20.css';
import { useNavigate } from 'react-router-dom';
import Toast from '../../Toast';
import logoImage from '../../../resources/1000028180.jpeg';
import { FiMenu } from 'react-icons/fi';

export default function MTT20ChallengePage() {
  const questions = [
    'I see setbacks as opportunities to learn and improve.',
    'I embrace uncertainty and adapt quickly to new challenges.',
    'I stay motivated even when faced with significant obstacles.',
    'I push myself beyond my comfort zone in training and competition.'
  ];

  const [responses, setResponses] = useState({});
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('warning');
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem('mtt20') || '{}');
    if (savedData.challenge && Array.isArray(savedData.challenge)) {
      const savedResponses = {};
      savedData.challenge.forEach((value, index) => {
        savedResponses[index] = Number(value);
      });
      setResponses(savedResponses);
    }
  }, []);

  const handleSelect = (questionIndex, rating) => {
    const updated = { ...responses, [questionIndex]: rating };
    setResponses(updated);

    const challengeArray = Object.keys(updated)
      .sort((a, b) => parseInt(a) - parseInt(b))
      .map((key) => updated[key]);

    const existing = JSON.parse(localStorage.getItem('mtt20') || '{}');
    localStorage.setItem('mtt20', JSON.stringify({
      ...existing,
      challenge: challengeArray,
    }));
  };

  const currentSection = 1;
  const totalSections = 4;
  const progressPercent = (currentSection / totalSections) * 100;

  const handleNext = () => {
    if (questions.some((_, idx) => !responses[idx])) {
      setToastMessage('Please answer all questions before proceeding.');
      setToastType('warning');
      setShowToast(true);
      return;
    }
    navigate('/MTT20CommitmentPage', { replace: true });
  };

  const handleCancel = () => {
    navigate('/dashboard');
  };

  const answerLabels = [
    'Strongly Disagree',
    'Disagree',
    'Neutral',
    'Agree',
    'Strongly Agree'
  ];

  return (
    <div style={{
      minHeight: '100vh',
      // background: 'linear-gradient(135deg, #e0f7f4 0%, #2AA7A1 100%)',
      background:` linear-gradient(to top left, #2AA7A1 -25.98%, #E0F7F4 66.42%)`,

      fontFamily: 'Poppins, sans-serif',
    }}>
      {/* Dashboard Navbar */}
      {/* <header className="dashboard-header" style={{position: 'static'}}>
        <div className="header-content">
          <h1 className="header-logo">Power Mind Metrics</h1>
          <nav className="header-nav">
            <button className="nav-link" onClick={() => navigate('/profile')}>Profile</button>
            <button className="nav-link" onClick={() => navigate('/logout')}>Logout</button>
          </nav>
        </div>
      </header> */}

<header className="dashboard-header" style={{position: 'static'}}>
        <div className="header-content">
          <div className="header-logo-container">
                                  <img
                        src={logoImage}
                        alt="Power Mind Metrics Logo"
                        style={{ height: "90px", width: "100px", marginRight: "10px" }}
                      />
            <h1 className="header-logo">Power Mind Metrics</h1>
          </div>
          <nav className="header-nav desktop-nav">
            <button className="nav-link" onClick={() => navigate('/profile')}>Profile</button>
            <button className="nav-link" onClick={() => navigate('/logout')}>Logout</button>
          </nav>
          <div className="mobile-nav-menu">
            <button className="hamburger-btn" onClick={() => setMobileMenuOpen(v => !v)}>
              <FiMenu size={28} />
            </button>
            {mobileMenuOpen && (
              <div className="mobile-nav-dropdown">
                <button className="nav-link" onClick={() => { setMobileMenuOpen(false); navigate('/profile'); }}>Profile</button>
                <button className="nav-link" onClick={() => { setMobileMenuOpen(false); navigate('/logout'); }}>Logout</button>
              </div>
            )}
          </div>
        </div>
      </header>
      {/* Main Card */}
      <div style={{
        minHeight: 'calc(100vh - 64px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 64,
      }}>
        <div
          className="mtt20-test-card"
          style={window.innerWidth > 600 ? {
            background: '#fff',
            borderRadius: 8,
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
            width: 1028,
            height: 900,
            padding: 30,
            gap: 40,
            opacity: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: 50,
          } : {}}
        >
          <h1 style={{fontWeight: 700, fontSize: 32, color: '#444', marginBottom: 16, textAlign: 'center'}}>MTT-20 Assessment</h1>
          <div style={{width: '100%', marginBottom: 24}}>
            <div style={{fontWeight: 500, fontSize: 20, marginBottom: 8}}>Step 1 of 4: <span style={{fontWeight: 600}}>Challenge</span></div>
            <div style={{display: 'flex', flexDirection: 'row', gap: 16, width: '100%', marginTop: 8, marginBottom: 8}}>
              {[1,2,3,4].map((step) => (
                <div
                  key={step}
                  style={{
                    flex: 1,
                    height: 10,
                    borderRadius: 6,
                    background: currentSection >= step ? '#2AA7A1' : '#e0e0e0',
                    transition: 'background 0.3s',
                  }}
                />
              ))}
            </div>
          </div>
          <form style={{width: '100%'}} onSubmit={e => { e.preventDefault(); handleNext(); }}>
            {questions.map((question, index) => (
              <div key={index} style={{marginBottom: 32}}>
                <div style={{fontWeight: 600, fontSize: 18, marginBottom: 8}}>{question}</div>
                {/* Mobile: show options in pairs of two per row */}
                {window.innerWidth > 600 ? (
                  <>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 4}}>
                      {answerLabels.map((label, i) => (
                        <span key={i} style={{fontSize: 13, color: '#444', width: 120, textAlign: 'center'}}>{label}</span>
                      ))}
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                      {[1,2,3,4,5].map((value) => (
                        <label key={value} style={{width: 120, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                          <input
                            type="radio"
                            name={`q${index}`}
                            value={value}
                            checked={responses[index] === value}
                            onChange={() => handleSelect(index, value)}
                            style={{width: 18, height: 18, accentColor: ' rgb(15, 148, 150)'}}
                          />
                        </label>
                      ))}
                    </div>
                  </>
                ) : (
                  // Mobile: pairs of two
                  (() => {
                    const pairs = [[1,2],[3,4],[5]];
                    return pairs.map((pair, rowIdx) => (
                      <div key={rowIdx} className="mtt20-options-pair-row">
                        {pair.map((value) => (
                          <label key={value} className="mtt20-option-label">
                            <input
                              type="radio"
                              name={`q${index}`}
                              value={value}
                              checked={responses[index] === value}
                              onChange={() => handleSelect(index, value)}
                              className="mtt20-radio"
                            />
                            <span className="mtt20-option-label-text">{answerLabels[value-1]}</span>
                          </label>
                        ))}
                      </div>
                    ));
                  })()
                )}
              </div>
            ))}
            <div style={{display: 'flex', width: '100%', justifyContent: 'space-between', marginTop: 24}}>
              <button
                type="button"
                onClick={handleCancel}
                style={{
                  border: '2px solid #2aa7a1',
                  background: '#fff',
                  color: '#2aa7a1',
                  borderRadius: 8,
                  fontWeight: 500,
                  fontSize: 16,
                  fontFamily: 'Poppins, sans-serif',
                  // padding: '10px 32px',
                  cursor: 'pointer',
                  transition: 'background 0.2s, color 0.2s',
                  height: 40,
                  width: 107,
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                style={{
                  border: 'none',
                  background: '#2aa7a1',
                  color: '#fff',
                  borderRadius: 8,
                  fontWeight: 500,
                  fontSize: 16,
                  fontFamily: 'Poppins, sans-serif',
                  padding: '8px 16px',
                  cursor: 'pointer',
                  transition: 'background 0.2s',
                  height: 40,
                  width: 107,
                }}
              >
                Next
              </button>
            </div>
          </form>
          {showToast && (
            <Toast
              message={toastMessage}
              type={toastType}
              onClose={() => setShowToast(false)}
            />
          )}
        </div>
      </div>
      
      {/* Footer */}
      <div className="mtt20-footer-mobile" style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        padding: '12px 0',
        textAlign: 'center',
        fontFamily: 'Poppins, sans-serif',
        zIndex: 100
      }}>
        <p style={{
          margin: 0,
          fontSize: '14px',
          color: 'rgba(75, 75, 75, 0.8)',
          fontWeight: 400
        }}>
          © 2025 All rights reserved Power Mind Metrics
        </p>
      </div>
    </div>
  );
}